import encryption from "./encryption/AES";
import file from "./file/file";
import date from "./date/publicDate";
import map from "./map/map";
import number from "./number/number";
import filter from "./filter/filter";
import getParamFn from "./getParam/getParam";
import role from "./role/role";
import base from "./base/base";
export default {
    ...encryption,
    ...file,
    ...date,
    ...map,
    ...number,
    ...filter,
    ...getParamFn,
    ...role,
    ...base
};
